import { render, staticRenderFns } from "./around_left_eye.vue?vue&type=template&id=9fe6a7a2"
import script from "./around_left_eye.vue?vue&type=script&lang=js"
export * from "./around_left_eye.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports